module.exports = __webpack_public_path__ + "img/tai_chinh.2cfc58df.png";